import React from 'react';
import ReactDOM from 'react-dom';
import { progressBarFetch, setOriginalFetch } from 'react-fetch-progressbar';
import App from './App';

import { unregister } from './registerServiceWorker';

document.themePath = 'http://localhost/taxispalais/wp-content/themes/taxispalais/';

document.jsonPath = 'https://www.taxispalais.art/';
//document.jsonPath = 'http://taxispalais.staging.florianmatthias.com/';

document.ajaxPath = 'https://www.taxispalais.art/wp-admin/admin-ajax.php';
//document.ajaxPath = 'http://taxispalais.staging.florianmatthias.com/wp-admin/admin-ajax.php';

document.language = '';

setOriginalFetch(window.fetch);
window.fetch = progressBarFetch;

ReactDOM.render(<App />, document.getElementById('root'));
unregister(); 



// WEBPACK FOOTER //
// ./src/index.js